(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3393],{

/***/ 58210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Likeicon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Likeicon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "19",
        height: "19",
        viewBox: "0 0 19 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M6.12392 3.71484C3.89812 3.71484 2.09375 5.50208 2.09375 7.70672C2.09375 11.6986 6.85668 15.3276 9.42134 16.1717C11.986 15.3276 16.7489 11.6986 16.7489 7.70672C16.7489 5.50208 14.9445 3.71484 12.7188 3.71484C11.3557 3.71484 10.1507 4.38508 9.42134 5.41096C8.69199 4.38508 7.48696 3.71484 6.12392 3.71484Z",
            stroke: "white",
            strokeWidth: "1.09914",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}


/***/ }),

/***/ 78436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Saveicon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Saveicon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13.3627 14.6227L8.66085 11.2643L3.95898 14.6227V3.87562C3.95898 3.51933 4.10052 3.17763 4.35245 2.9257C4.60439 2.67376 4.94609 2.53223 5.30238 2.53223H12.0193C12.3756 2.53223 12.7173 2.67376 12.9692 2.9257C13.2212 3.17763 13.3627 3.51933 13.3627 3.87562V14.6227Z",
            stroke: "white",
            strokeWidth: "1.00754",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}


/***/ }),

/***/ 63418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Shareicon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Shareicon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M13.4346 6.64655C14.6487 6.64655 15.6329 5.66235 15.6329 4.44828C15.6329 3.2342 14.6487 2.25 13.4346 2.25C12.2205 2.25 11.2363 3.2342 11.2363 4.44828C11.2363 5.66235 12.2205 6.64655 13.4346 6.64655Z",
                stroke: "white",
                strokeWidth: "1.09914",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M4.64164 11.7755C5.85571 11.7755 6.83991 10.7913 6.83991 9.57718C6.83991 8.36311 5.85571 7.37891 4.64164 7.37891C3.42756 7.37891 2.44336 8.36311 2.44336 9.57718C2.44336 10.7913 3.42756 11.7755 4.64164 11.7755Z",
                stroke: "white",
                strokeWidth: "1.09914",
                strokeLinecap: "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M13.4346 16.9044C14.6487 16.9044 15.6329 15.9202 15.6329 14.7061C15.6329 13.492 14.6487 12.5078 13.4346 12.5078C12.2205 12.5078 11.2363 13.492 11.2363 14.7061C11.2363 15.9202 12.2205 16.9044 13.4346 16.9044Z",
                stroke: "white",
                strokeWidth: "1.09914",
                strokeLinecap: "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.53906 10.6836L11.5438 13.6",
                stroke: "white",
                strokeWidth: "1.09914",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11.5365 5.55469L6.53906 8.47107",
                stroke: "white",
                strokeWidth: "1.09914",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/***/ }),

/***/ 81630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SubCategoryProductSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_components_ProductPage_AllProduct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55317);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);




function SubCategoryProductSection(param) {
    var category = param.category, subCategory = param.subCategory, fetchUpdatedProduct = param.fetchUpdatedProduct, page = param.page, setPage = param.setPage, productData = param.productData, _childSubCategory = param.childSubCategory, childSubCategory = _childSubCategory === void 0 ? null : _childSubCategory;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(40), dataLimite = ref1[0], setDataLimite = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        subCategory: [],
        category: []
    }), filterData = ref2[0], setFilterData = ref2[1];
    // const productByCategory = useSelector((state: any) => state?.productByCategory)
    var sub_category_slug = router === null || router === void 0 ? void 0 : router.pathname.split("/")[2];
    // productByCategory?.product?.getAllProducts
    var responseProducts = productData === null || productData === void 0 ? void 0 : (ref = productData.product) === null || ref === void 0 ? void 0 : ref.getAllProducts;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "store-page bg-white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "feature-product-align",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "store-page-cover-info",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_ProductPage_AllProduct__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    products: responseProducts === null || responseProducts === void 0 ? void 0 : responseProducts.data,
                    isCalled: productData === null || productData === void 0 ? void 0 : productData.called,
                    storeId: 0,
                    category_slug: category,
                    subCategory_slug: subCategory,
                    childSubCategory_slug: childSubCategory,
                    store_slug: null,
                    color: "#FFFFFF",
                    isFilterMenu: true,
                    total: responseProducts === null || responseProducts === void 0 ? void 0 : responseProducts.total,
                    dataLimite: dataLimite,
                    setPage: setPage,
                    page: page,
                    // topForFilter={34}
                    topForFilter: 99,
                    isMobile: true,
                    setFilterData: setFilterData,
                    filterData: filterData,
                    APIcall: fetchUpdatedProduct
                })
            })
        })
    });
}


/***/ }),

/***/ 61625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BrowseCatagory; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _BrowseCatagory_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16516);
/* harmony import */ var _BrowseCatagory_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_BrowseCatagory_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var src_store_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74573);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var src_graphql_queries_getSingleCategory__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16544);
/* harmony import */ var src_utils_apolloClient__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16915);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
// @ts-nocheck













function SampleNextArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/assets/icon/right-icon-black.svg",
            alt: "RightArrow"
        })
    });
}
function SamplePrevArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/assets/icon/left-icon-black.svg",
            alt: "LeftArrow"
        })
    });
}
function BrowseCatagory(param) {
    var backgroundColor = param.backgroundColor, imageBackgroundColor = param.imageBackgroundColor, imageArray = param.imageArray, fontColor = param.fontColor, subcategoryName = param.subcategoryName, sub_category_slug = param.sub_category_slug, childsubSlug = param.childsubSlug;
    var dispatch = (0,src_store_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppDispatch */ .T)();
    var categoryData = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.fetchCategory) === null || ref === void 0 ? void 0 : ref.categoryData;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), nestedChildCategory = ref[0], setNestedChildCategory = ref[1];
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SampleNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SamplePrevArrow, {}),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }, 
        ]
    };
    var fetchNestedChildCategory = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var ref, ref1, data, ref2;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            src_utils_apolloClient__WEBPACK_IMPORTED_MODULE_6__/* ["default"].query */ .Z.query({
                                query: src_graphql_queries_getSingleCategory__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
                                variables: {
                                    type: "CHILD_SUB_CATEGORY",
                                    categoryName: "Fashion & Accessories",
                                    subcategoryName: subcategoryName,
                                    childsubSlug: "",
                                    nestedSlug: ""
                                },
                                fetchPolicy: "network-only"
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : (ref = data.getSingleCategory) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.length) {
                            ;
                            setNestedChildCategory(data === null || data === void 0 ? void 0 : (ref2 = data.getSingleCategory) === null || ref2 === void 0 ? void 0 : ref2.data);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchNestedChildCategory() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        fetchNestedChildCategory();
    }, []);
    return (nestedChildCategory === null || nestedChildCategory === void 0 ? void 0 : nestedChildCategory.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_BrowseCatagory_module_scss__WEBPACK_IMPORTED_MODULE_10___default().BrowseCatagoryTitle),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    children: "Browse by Category"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_BrowseCatagory_module_scss__WEBPACK_IMPORTED_MODULE_10___default().BrowseCatagoryMain),
                style: {
                    backgroundColor: backgroundColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_BrowseCatagory_module_scss__WEBPACK_IMPORTED_MODULE_10___default().BrowseCatagorySliderMain),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, settings), {
                        children: nestedChildCategory === null || nestedChildCategory === void 0 ? void 0 : nestedChildCategory.map(function(img) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                                href: "/fashion/".concat(subcategoryName, "/").concat(img === null || img === void 0 ? void 0 : img.slug),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_BrowseCatagory_module_scss__WEBPACK_IMPORTED_MODULE_10___default().BrowseCatagorySliderboxMain),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_BrowseCatagory_module_scss__WEBPACK_IMPORTED_MODULE_10___default().BrowseCatagorySliderbox),
                                            style: {
                                                backgroundColor: imageBackgroundColor
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: img === null || img === void 0 ? void 0 : img.media,
                                                alt: "Bagimage"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            style: {
                                                color: fontColor
                                            },
                                            children: img === null || img === void 0 ? void 0 : img.name
                                        })
                                    ]
                                })
                            });
                        })
                    }))
                })
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
}


/***/ }),

/***/ 67679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CategoryDetail; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CategoryDetail(param) {
    var filterData = param.filterData, caterogoyName = param.caterogoyName, fontColor = param.fontColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "category-by-shoes-banner-details-section",
            style: {
                borderRadius: caterogoyName === "accessories" ? "16px" : ""
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "category-by-shoes-banner",
                    children: (filterData === null || filterData === void 0 ? void 0 : filterData.banner_media) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: filterData === null || filterData === void 0 ? void 0 : filterData.banner_media,
                        alt: "womens_images"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "category-by-shoes-banner-section",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "category-by-shoes-heading-alignment",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                    style: {
                                        color: fontColor
                                    },
                                    children: filterData === null || filterData === void 0 ? void 0 : filterData.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    style: {
                                        color: fontColor
                                    },
                                    children: filterData === null || filterData === void 0 ? void 0 : filterData.description
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 11659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ JeweleryarrivalAcceccories; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69779);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _JeweleryarrivalAcceccories_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68271);
/* harmony import */ var _JeweleryarrivalAcceccories_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_JeweleryarrivalAcceccories_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var src_store_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74573);
/* harmony import */ var src_store_slices_manageModalSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89013);
/* harmony import */ var src_store_slices_mobileModalSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64965);
/* harmony import */ var src_store_slices_fetchAllProduct__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87789);
/* harmony import */ var public_assets_svg_Saveicon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78436);
/* harmony import */ var public_assets_svg_Likeicon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58210);
/* harmony import */ var public_assets_svg_Shareicon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63418);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_11__);
// @ts-nocheck












// const saveicon = '/assets/icon/save.png'
// const shareicon = '/assets/icon/share.png'
// const likeicon = '/assets/icon/like.png'




// Custom arrow components for the slider
function SampleNextArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/assets/icon/right-icon-black.svg",
            alt: "RightArrow"
        })
    });
}
function SamplePrevArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/assets/icon/left-icon-black.svg",
            alt: "LeftArrow"
        })
    });
}
function JeweleryarrivalAcceccories(param) {
    var category = param.category, subCategory = param.subCategory, childSubCategory = param.childSubCategory;
    var settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4.7,
        slidesToScroll: 3,
        nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SampleNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SamplePrevArrow, {}),
        centerMode: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    centerMode: false,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2.2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    centerMode: false,
                    infinite: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2.2,
                    slidesToScroll: 1,
                    centerMode: false,
                    infinite: true
                }
            }, 
        ]
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_11__.useRouter)();
    var fetchMobileModal = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageMobileModal) === null || ref === void 0 ? void 0 : ref.data;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), products = ref[0], setProducts = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(2), page = ref1[0], setPage = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(10), dataLimite = ref2[0], setDataLimite = ref2[1];
    var getAllState = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageModalData) === null || ref === void 0 ? void 0 : ref.data;
    });
    var dispatch = (0,src_store_store__WEBPACK_IMPORTED_MODULE_4__/* .useAppDispatch */ .T)();
    var handleOpen = function() {
        dispatch((0,src_store_slices_manageModalSlice__WEBPACK_IMPORTED_MODULE_5__/* .fetchModalData */ .w)({
            allModalData: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(getAllState === null || getAllState === void 0 ? void 0 : getAllState.allModalData).concat([
                {
                    modal: "ShopnewArrivalSeeAll",
                    isOpen: true,
                    id: {
                        title: "New Arrival",
                        description: "New Arrival products! Dive in and discover what delights you",
                        color: "linear-gradient(90deg, #65459C 0%, #8C8894 100%)",
                        category: category,
                        subCategory: subCategory,
                        childSubCategory: childSubCategory,
                        isShopifyProduct: false,
                        page: 1,
                        limit: 30
                    },
                    modalFor: "bigModal"
                }, 
            ]),
            lastModalData: getAllState === null || getAllState === void 0 ? void 0 : getAllState.lastModalData
        }));
    };
    var handleMobileOpen = function() {
        dispatch((0,src_store_slices_mobileModalSlice__WEBPACK_IMPORTED_MODULE_6__/* .fetchMobileModalData */ .B)({
            allModalData: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((fetchMobileModal === null || fetchMobileModal === void 0 ? void 0 : fetchMobileModal.allModalData) ? fetchMobileModal === null || fetchMobileModal === void 0 ? void 0 : fetchMobileModal.allModalData : []).concat([
                {
                    modal: "mobileJewelryModal",
                    isOpen: true,
                    id: {
                        title: "New Arrival",
                        description: "New Arrival products! Dive in and discover what delights you",
                        color: "linear-gradient(90deg, #65459C 0%, #8C8894 100%)",
                        image: ""
                    },
                    transform: 16
                }, 
            ]),
            lastModalData: fetchMobileModal === null || fetchMobileModal === void 0 ? void 0 : fetchMobileModal.lastModalData
        }));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        dispatch((0,src_store_slices_fetchAllProduct__WEBPACK_IMPORTED_MODULE_7__/* .fetchProductByCategory */ .h4)({
            category: category,
            subCategory: subCategory,
            childSubCategory: childSubCategory,
            isShopifyProduct: false,
            page: page,
            limit: dataLimite
        })).then(function(res) {
            var ref, ref1;
            setProducts(res === null || res === void 0 ? void 0 : (ref = res.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.getAllProducts) === null || ref1 === void 0 ? void 0 : ref1.data);
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_JeweleryarrivalAcceccories_module_scss__WEBPACK_IMPORTED_MODULE_13___default().JeweleryarrivalAcceccories),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_JeweleryarrivalAcceccories_module_scss__WEBPACK_IMPORTED_MODULE_13___default().Jeweleryarrivalflxmain),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_JeweleryarrivalAcceccories_module_scss__WEBPACK_IMPORTED_MODULE_13___default().Jeweleryarrivalitemsone),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        children: "New Arrival"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_JeweleryarrivalAcceccories_module_scss__WEBPACK_IMPORTED_MODULE_13___default().Webmodalbutton),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: function() {
                                        return handleOpen();
                                    },
                                    children: "See All"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_JeweleryarrivalAcceccories_module_scss__WEBPACK_IMPORTED_MODULE_13___default().Mobilemodalbutton),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: function() {
                                        return handleMobileOpen();
                                    },
                                    children: "See All"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_JeweleryarrivalAcceccories_module_scss__WEBPACK_IMPORTED_MODULE_13___default().Jeweleryarrivalitemstwo),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, settings), {
                            children: products === null || products === void 0 ? void 0 : products.map(function(product, index) {
                                var ref, ref1;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_JeweleryarrivalAcceccories_module_scss__WEBPACK_IMPORTED_MODULE_13___default().Jeweleryarrivalsaliderboxmain),
                                        onClick: function() {
                                            router.push("/product/".concat(product === null || product === void 0 ? void 0 : product.slug));
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_JeweleryarrivalAcceccories_module_scss__WEBPACK_IMPORTED_MODULE_13___default().Jeweleryarrivalsaliderbox),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.src,
                                                    alt: "jewelryslide1"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_JeweleryarrivalAcceccories_module_scss__WEBPACK_IMPORTED_MODULE_13___default().sliderhover),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (_JeweleryarrivalAcceccories_module_scss__WEBPACK_IMPORTED_MODULE_13___default().Sliderhoverinner),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: (_JeweleryarrivalAcceccories_module_scss__WEBPACK_IMPORTED_MODULE_13___default().Sliderhgovercontentone),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        children: product === null || product === void 0 ? void 0 : product.title
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                        children: [
                                                                            "$",
                                                                            (product === null || product === void 0 ? void 0 : product.dis_price) || 0
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: (_JeweleryarrivalAcceccories_module_scss__WEBPACK_IMPORTED_MODULE_13___default().Sliderhgovercontenttwo),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_assets_svg_Saveicon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_assets_svg_Shareicon__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_assets_svg_Likeicon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                });
                            })
                        }))
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 74759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ShopByCategoryDetails; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Category/ShopByCategoryDetails/ShopByCategoryDetails.module.scss
var ShopByCategoryDetails_module = __webpack_require__(16217);
var ShopByCategoryDetails_module_default = /*#__PURE__*/__webpack_require__.n(ShopByCategoryDetails_module);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./src/components/Category/ShopByCategoryDetails/HotWatches/HotWatches.module.scss
var HotWatches_module = __webpack_require__(34684);
var HotWatches_module_default = /*#__PURE__*/__webpack_require__.n(HotWatches_module);
// EXTERNAL MODULE: ./src/components/Category/ShopByCategoryDetails/CategoryProduct/index.tsx
var CategoryProduct = __webpack_require__(76113);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/store/store.tsx + 6 modules
var store = __webpack_require__(74573);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/store/slices/mobileModalSlice.tsx
var mobileModalSlice = __webpack_require__(64965);
// EXTERNAL MODULE: ./src/store/slices/fetchAllProduct.tsx
var fetchAllProduct = __webpack_require__(87789);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/Category/ShopByCategoryDetails/HotWatches/index.tsx
// @ts-nocheck














function SampleNextArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (HotWatches_module_default()).nextArrowAlignment,
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 6L15 12L9 18",
                stroke: "#7A7E88",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
}
function SamplePrevArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (HotWatches_module_default()).prevArrowAlignment,
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 18L9 12L15 6",
                stroke: "#7A7E88",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
}
function HotWatches() {
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SampleNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SamplePrevArrow, {})
    };
    var dispatch = (0,store/* useAppDispatch */.T)();
    var router = (0,next_router.useRouter)();
    var getAllState = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageModalData) === null || ref === void 0 ? void 0 : ref.data;
    });
    var fetchMobileModal = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageMobileModal) === null || ref === void 0 ? void 0 : ref.data;
    });
    var ref = (0,react.useState)([]), hotWatchesData = ref[0], setHotWatchesData = ref[1];
    (0,react.useEffect)(function() {
        fetchProduct();
    }, []);
    var handleClose = function() {
        router.push("/feed");
    };
    var fetchProduct = function() {
        var ref, ref1;
        dispatch((0,fetchAllProduct/* fetchProductByCategory */.h4)({
            category: "fashion-and-accessories",
            subCategory: (router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes("women")) ? "women-accessories" : "men-accessories",
            childSubCategory: (router === null || router === void 0 ? void 0 : (ref1 = router.asPath) === null || ref1 === void 0 ? void 0 : ref1.includes("women")) ? "sunglasses" : "sunglasses",
            isShopifyProduct: false,
            page: 1,
            limit: 6
        })).then(function(response) {
            var ref, ref1;
            setHotWatchesData(response === null || response === void 0 ? void 0 : (ref = response.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.getAllProducts) === null || ref1 === void 0 ? void 0 : ref1.data);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (HotWatches_module_default()).hotWatchesSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HotWatches_module_default()).hotWatchesHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "Hot Watches"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((HotWatches_module_default()).seeMoreButton, (HotWatches_module_default()).mobileview),
                        onClick: function() {
                            return dispatch((0,mobileModalSlice/* fetchMobileModalData */.B)({
                                allModalData: (0,_to_consumable_array/* default */.Z)((fetchMobileModal === null || fetchMobileModal === void 0 ? void 0 : fetchMobileModal.allModalData) ? fetchMobileModal === null || fetchMobileModal === void 0 ? void 0 : fetchMobileModal.allModalData : []).concat([
                                    {
                                        modal: "mobileHotWatches",
                                        isOpen: true,
                                        id: 0,
                                        transform: 60
                                    }, 
                                ]),
                                lastModalData: fetchMobileModal === null || fetchMobileModal === void 0 ? void 0 : fetchMobileModal.lastModalData
                            }));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: "See more"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HotWatches_module_default()).hotWatchesDetailsBox,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HotWatches_module_default()).watchesSliderImg,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                            children: [
                                0,
                                1,
                                2,
                                3,
                                4,
                                5
                            ].map(function(_, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (HotWatches_module_default()).hotWatchesBannerImg,
                                    onClick: function() {
                                        router.push("/");
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/assets/img/new-banner-img.png",
                                        alt: "new banner"
                                    })
                                }, index);
                            })
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HotWatches_module_default()).hotWatchesAllDetails,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HotWatches_module_default()).hotWatchesGrid,
                            children: hotWatchesData === null || hotWatchesData === void 0 ? void 0 : hotWatchesData.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (HotWatches_module_default()).hotWatchesGridItem,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryProduct/* default */.Z, {
                                        index: index,
                                        item: item
                                    })
                                }, "r".concat(index));
                            })
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Category/ShopByCategoryDetails/SpecialOffers/SpecialOffers.module.scss
var SpecialOffers_module = __webpack_require__(73784);
var SpecialOffers_module_default = /*#__PURE__*/__webpack_require__.n(SpecialOffers_module);
;// CONCATENATED MODULE: ./src/components/Category/ShopByCategoryDetails/SpecialOffers/index.tsx








function SpecialOffers(param) {
    var backgroundColor = param.backgroundColor;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var router = (0,next_router.useRouter)();
    var getAllState = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageModalData) === null || ref === void 0 ? void 0 : ref.data;
    });
    var fetchMobileModal = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageMobileModal) === null || ref === void 0 ? void 0 : ref.data;
    });
    var ref = (0,react.useState)([]), specialOffersData = ref[0], setSpecialOffersData = ref[1];
    (0,react.useEffect)(function() {
        fetchProduct();
    }, []);
    var fetchProduct = function() {
        var ref, ref1;
        dispatch((0,fetchAllProduct/* fetchProductByCategory */.h4)({
            category: "fashion-and-accessories",
            subCategory: (router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes("women")) ? "women-accessories" : "men-accessories",
            childSubCategory: (router === null || router === void 0 ? void 0 : (ref1 = router.asPath) === null || ref1 === void 0 ? void 0 : ref1.includes("women")) ? "scarves" : "hats",
            isShopifyProduct: false,
            page: 1,
            limit: 12
        })).then(function(response) {
            var ref, ref1;
            setSpecialOffersData(response === null || response === void 0 ? void 0 : (ref = response.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.getAllProducts) === null || ref1 === void 0 ? void 0 : ref1.data);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SpecialOffers_module_default()).specialOffersSetion,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SpecialOffers_module_default()).specialOffersHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    children: "Special Offers"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SpecialOffers_module_default()).specialOffersBodyAlignment,
                style: {
                    backgroundColor: backgroundColor
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SpecialOffers_module_default()).specialOffersGrid,
                    children: specialOffersData === null || specialOffersData === void 0 ? void 0 : specialOffersData.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SpecialOffers_module_default()).specialOffersGridItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryProduct/* default */.Z, {
                                index: index,
                                item: item
                            })
                        }, "c".concat(index));
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Jewelry/JewelryClubs/index.tsx
var JewelryClubs = __webpack_require__(69643);
// EXTERNAL MODULE: ./src/components/Category/MainCategory/WomenCategory/WomanPageModal/Weekoffersection/Weekofoffersection.module.scss
var Weekofoffersection_module = __webpack_require__(36320);
var Weekofoffersection_module_default = /*#__PURE__*/__webpack_require__.n(Weekofoffersection_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomanPageModal/Weekoffersection/index.tsx




// const Watchimage = '/assets/accessories/watch.png'
// const SaleTicketImage = '/assets/accessories/saleticketimage.png'
var menfashion = "/assets/img/menfashion.png";
var menvision = "/assets/img/menvision.png";
function Weekofoffersection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Weekofoffersection_module_default()).WeekofoffersectionMain,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/search/?q=backpack&type=product",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: menfashion,
                        alt: "menfashion"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/store/biscayners/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: menvision,
                        alt: "menvision"
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Category/ShopByCategoryDetails/index.tsx












function ShopByCategoryDetails(param) {
    var category_id = param.category_id, subCategory_id = param.subCategory_id, storetitle = param.storetitle, storeModalName = param.storeModalName, clubTitle = param.clubTitle, dataLimite = param.dataLimite, setPage = param.setPage, page = param.page;
    var productByCategory = (0,es/* useSelector */.v9)(function(state) {
        return state === null || state === void 0 ? void 0 : state.productByCategory;
    });
    var dispatch = (0,store/* useAppDispatch */.T)();
    var ref = (0,react.useState)({
        subCategory: [],
        category: []
    }), filterData = ref[0], setFilterData = ref[1];
    (0,react.useEffect)(function() {
        setPage(1);
        fetchProduct();
    }, []);
    var fetchProduct = function() {
        dispatch((0,fetchAllProduct/* fetchProductByCategory */.h4)({
            category: "fashion-and-accessories",
            subCategory: "men",
            childSubCategory: "",
            isShopifyProduct: false,
            page: page,
            limit: dataLimite
        }));
    };
    var fetchUpdatedProduct = function(product_id, type) {
        var update_product = [];
        if (type === "dislike") {
            var ref, ref1, ref2;
            update_product = productByCategory === null || productByCategory === void 0 ? void 0 : (ref = productByCategory.product) === null || ref === void 0 ? void 0 : (ref1 = ref.getAllProducts) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.total) === null || ref2 === void 0 ? void 0 : ref2.map(function(prd) {
                if ((prd === null || prd === void 0 ? void 0 : prd.id) === product_id) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prd), {
                        likes: null
                    });
                } else {
                    return prd;
                }
            });
        } else if (type === "like") {
            var ref3, ref4, ref5;
            update_product = productByCategory === null || productByCategory === void 0 ? void 0 : (ref3 = productByCategory.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.getAllProducts) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.total) === null || ref5 === void 0 ? void 0 : ref5.map(function(prd) {
                if ((prd === null || prd === void 0 ? void 0 : prd.id) === product_id) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prd), {
                        likes: {
                            id: 3.3333
                        }
                    });
                } else {
                    return prd;
                }
            });
        }
        dispatch((0,fetchAllProduct/* setProductByCategoryState */.wW)({
            getAllProducts: {
                data: update_product
            }
        }));
        fetchProduct();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ShopByCategoryDetails_module_default()).shopByCategorySection,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container mobile-view-padding-zero",
            style: {
                maxWidth: "1300px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ShopByCategoryDetails_module_default()).shopByCategoryChildDetails,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HotWatches, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialOffers, {
                                backgroundColor: "rgba(33, 62, 78, 0.40)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Weekofoffersection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JewelryClubs/* default */.Z, {
                        title: clubTitle
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 69643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ JewelryClubs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9941);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69779);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _JewelryClubs_module_scss__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(19746);
/* harmony import */ var _JewelryClubs_module_scss__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_JewelryClubs_module_scss__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var src_graphql_queries_sellerQueries_getJoinedGroups__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85357);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(50319);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var src_components_StoreAndProductDetailModal_ClubModal_ClubSlider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14333);
/* harmony import */ var src_graphql_mutations_leaveGroup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72327);
/* harmony import */ var src_graphql_mutations_joinGroup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9031);
/* harmony import */ var src_utils_auth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23174);
/* harmony import */ var src_graphql_queries_getGroups__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53641);
/* harmony import */ var src_graphql_queries_sellerQueries_getGlobalSearchWithElasticSearch__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65336);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9473);
/* harmony import */ var src_store_store__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(74573);
/* harmony import */ var src_store_slices_manageModalSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89013);
/* harmony import */ var src_store_slices_fetchAllClubsSlice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15438);
// @ts-nocheck




















function SampleNextArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/assets/icon/right-icon-black.svg",
            alt: "RightArrow"
        })
    });
}
function SamplePrevArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/assets/icon/left-icon-black.svg",
            alt: "LeftArrow"
        })
    });
}
function JewelryClubs(param) {
    var title = param.title;
    var user = (0,src_utils_auth__WEBPACK_IMPORTED_MODULE_7__/* .useAuth */ .a)().user;
    var fetchSearchModalData = (0,react_redux__WEBPACK_IMPORTED_MODULE_10__/* .useSelector */ .v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.searchModalSlice) === null || ref === void 0 ? void 0 : ref.data;
    });
    var dispatch = (0,src_store_store__WEBPACK_IMPORTED_MODULE_11__/* .useAppDispatch */ .T)();
    var fetchMobileModal = (0,react_redux__WEBPACK_IMPORTED_MODULE_10__/* .useSelector */ .v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageMobileModal) === null || ref === void 0 ? void 0 : ref.data;
    });
    var getAllState = (0,react_redux__WEBPACK_IMPORTED_MODULE_10__/* .useSelector */ .v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageModalData) === null || ref === void 0 ? void 0 : ref.data;
    });
    var allManageClub = (0,react_redux__WEBPACK_IMPORTED_MODULE_10__/* .useSelector */ .v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.clubData) === null || ref === void 0 ? void 0 : ref.manageClubs;
    });
    var settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 2.8,
        slidesToScroll: 1,
        nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SampleNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SamplePrevArrow, {}),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 899,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    infinite: false,
                    centerMode: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1.3,
                    initialSlide: 1,
                    infinite: false,
                    centerMode: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.1,
                    slidesToScroll: 1,
                    infinite: false,
                    centerMode: false
                }
            }, 
        ]
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        dispatch((0,src_store_slices_fetchAllClubsSlice__WEBPACK_IMPORTED_MODULE_13__/* .fetchManageClubsData */ .mG)({
            page: 1,
            limit: 100,
            type: "SUGGESTED_CLUBS"
        }));
    }, []);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_15__/* .useMutation */ .D)(src_graphql_mutations_leaveGroup__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        onCompleted: function(res) {
            dispatch((0,src_store_slices_fetchAllClubsSlice__WEBPACK_IMPORTED_MODULE_13__/* .fetchJoinedClubsData */ .C6)({
                page: 1,
                limit: 100,
                type: "JOIN_CLUBS"
            }));
            dispatch((0,src_store_slices_fetchAllClubsSlice__WEBPACK_IMPORTED_MODULE_13__/* .fetchAllClubSliceData */ .w2)({
                page: 1,
                limit: 100,
                type: "SUGGESTED_CLUBS",
                prevPost: []
            }));
            dispatch((0,src_store_slices_fetchAllClubsSlice__WEBPACK_IMPORTED_MODULE_13__/* .fetchManageClubsData */ .mG)({
                page: 1,
                limit: 100,
                type: "CLUBS_YOU_MANAGE"
            }));
        },
        onError: function(err) {}
    }), 1), leaveGroup = ref[0];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_15__/* .useMutation */ .D)(src_graphql_mutations_joinGroup__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        onCompleted: function(res) {
            dispatch((0,src_store_slices_fetchAllClubsSlice__WEBPACK_IMPORTED_MODULE_13__/* .fetchJoinedClubsData */ .C6)({
                page: 1,
                limit: 100,
                type: "JOIN_CLUBS"
            }));
            dispatch((0,src_store_slices_fetchAllClubsSlice__WEBPACK_IMPORTED_MODULE_13__/* .fetchAllClubSliceData */ .w2)({
                page: 1,
                limit: 100,
                type: "SUGGESTED_CLUBS",
                prevPost: []
            }));
            dispatch((0,src_store_slices_fetchAllClubsSlice__WEBPACK_IMPORTED_MODULE_13__/* .fetchManageClubsData */ .mG)({
                page: 1,
                limit: 100,
                type: "CLUBS_YOU_MANAGE"
            }));
        },
        onError: function(err) {}
    }), 1), joingroup = ref1[0];
    var leaveGroupCall = function(club) {
        leaveGroup({
            variables: {
                userId: user.id,
                groupId: club === null || club === void 0 ? void 0 : club.id
            },
            update: function(proxy, param) {
                var data = param.data;
                var ref, ref1;
                var joinedGroup = proxy.readQuery({
                    query: src_graphql_queries_sellerQueries_getJoinedGroups__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
                });
                var updatedData = joinedGroup === null || joinedGroup === void 0 ? void 0 : (ref = joinedGroup.getJoinedGroups) === null || ref === void 0 ? void 0 : ref.filter(function(grp) {
                    return (grp === null || grp === void 0 ? void 0 : grp.id) !== (club === null || club === void 0 ? void 0 : club.id);
                });
                proxy.writeQuery({
                    query: src_graphql_queries_sellerQueries_getJoinedGroups__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                    data: {
                        getJoinedGroups: updatedData
                    }
                });
                var suggestedGroup = proxy.readQuery({
                    query: src_graphql_queries_getGroups__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z
                });
                proxy.writeQuery({
                    query: src_graphql_queries_getGroups__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
                    data: {
                        groups: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(suggestedGroup === null || suggestedGroup === void 0 ? void 0 : suggestedGroup.groups).concat([
                            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, club), {
                                isFollow: false,
                                members: club === null || club === void 0 ? void 0 : (ref1 = club.members) === null || ref1 === void 0 ? void 0 : ref1.filter(function(grp) {
                                    return (grp === null || grp === void 0 ? void 0 : grp.id) !== (user === null || user === void 0 ? void 0 : user.id);
                                })
                            }), 
                        ])
                    }
                });
            }
        });
    };
    var joingroupCall = function(club) {
        joingroup({
            variables: {
                group_id: club === null || club === void 0 ? void 0 : club.id,
                user_id: user === null || user === void 0 ? void 0 : user.id,
                isAdmin: false
            },
            update: function(proxy, param) {
                var data = param.data;
                var ref, ref1, ref2, ref3;
                var dataInCache = proxy.readQuery({
                    query: src_graphql_queries_sellerQueries_getGlobalSearchWithElasticSearch__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
                    variables: {
                        search: fetchSearchModalData === null || fetchSearchModalData === void 0 ? void 0 : fetchSearchModalData.search,
                        limit: 10,
                        page: 0
                    }
                });
                var updatedData = dataInCache === null || dataInCache === void 0 ? void 0 : (ref = dataInCache.globalSearchWithElasticSearch) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.groups) === null || ref2 === void 0 ? void 0 : ref2.map(function(grp) {
                    if ((club === null || club === void 0 ? void 0 : club.id) === (grp === null || grp === void 0 ? void 0 : grp.id)) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, grp), {
                            isFollow: true,
                            members: [
                                {
                                    firstName: user === null || user === void 0 ? void 0 : user.firstName,
                                    lastName: user === null || user === void 0 ? void 0 : user.lastName,
                                    id: user === null || user === void 0 ? void 0 : user.id,
                                    profileUrl: user === null || user === void 0 ? void 0 : user.logo_image
                                }, 
                            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(grp === null || grp === void 0 ? void 0 : grp.members))
                        });
                    } else {
                        return grp;
                    }
                });
                var datass = proxy.writeQuery({
                    query: src_graphql_queries_sellerQueries_getGlobalSearchWithElasticSearch__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
                    data: {
                        globalSearchWithElasticSearch: {
                            data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, dataInCache === null || dataInCache === void 0 ? void 0 : (ref3 = dataInCache.globalSearchWithElasticSearch) === null || ref3 === void 0 ? void 0 : ref3.data), {
                                groups: updatedData
                            })
                        }
                    }
                });
            }
        });
    };
    var handleOpenModal = function() {
        dispatch((0,src_store_slices_manageModalSlice__WEBPACK_IMPORTED_MODULE_12__/* .fetchModalData */ .w)({
            allModalData: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(getAllState === null || getAllState === void 0 ? void 0 : getAllState.allModalData).concat([
                {
                    modal: "jewelryCLubModal",
                    isOpen: true,
                    id: {
                        title: title
                    },
                    modalFor: "bigModal"
                }, 
            ]),
            lastModalData: getAllState === null || getAllState === void 0 ? void 0 : getAllState.lastModalData
        }));
    };
    return Boolean(allManageClub === null || allManageClub === void 0 ? void 0 : allManageClub.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_JewelryClubs_module_scss__WEBPACK_IMPORTED_MODULE_19___default().jewelryClubsSection),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_JewelryClubs_module_scss__WEBPACK_IMPORTED_MODULE_19___default().jewelryClubflxmain),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_JewelryClubs_module_scss__WEBPACK_IMPORTED_MODULE_19___default().JeweleryClubheading),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                children: "Popular Accessory Clubs"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Finding the accessories club for women"
                            })
                        ]
                    }),
                    (allManageClub === null || allManageClub === void 0 ? void 0 : allManageClub.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_JewelryClubs_module_scss__WEBPACK_IMPORTED_MODULE_19___default().clubModalDetailsAllDetailsAlignment),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, settings), {
                            children: allManageClub === null || allManageClub === void 0 ? void 0 : allManageClub.map(function(club, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_StoreAndProductDetailModal_ClubModal_ClubSlider__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        club: club,
                                        leaveGroupCall: leaveGroupCall,
                                        joingroupCall: joingroupCall,
                                        isOpen: true
                                    })
                                }, index);
                            })
                        }))
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_JewelryClubs_module_scss__WEBPACK_IMPORTED_MODULE_19___default().noFollowingStoreDetailsAlignment)
                    })
                ]
            })
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
}


/***/ }),

/***/ 16516:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BrowseCatagoryTitle":"BrowseCatagory_BrowseCatagoryTitle__h6dYX","BrowseCatagorySliderMainsc":"BrowseCatagory_BrowseCatagorySliderMainsc__EMqwh","BrowseCatagorySlidermobile":"BrowseCatagory_BrowseCatagorySlidermobile__Am6dB","BrowseCatagorySlidermobilecol1":"BrowseCatagory_BrowseCatagorySlidermobilecol1__c78bX","BrowseCatagorySlidermobilecol1imagediv":"BrowseCatagory_BrowseCatagorySlidermobilecol1imagediv__R_qn2","BrowseCatagoryMain":"BrowseCatagory_BrowseCatagoryMain__F4hq9","BrowseCatagorySliderMain":"BrowseCatagory_BrowseCatagorySliderMain__CYf3X","BrowseCatagorySliderboxMain":"BrowseCatagory_BrowseCatagorySliderboxMain__X2hqx","BrowseCatagorySliderbox":"BrowseCatagory_BrowseCatagorySliderbox__aTjDd"};

/***/ }),

/***/ 68271:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"JeweleryarrivalAcceccories":"JeweleryarrivalAcceccories_JeweleryarrivalAcceccories__X_jB5","Jeweleryarrivalflxmain":"JeweleryarrivalAcceccories_Jeweleryarrivalflxmain__mOIDO","Jeweleryarrivalitemsone":"JeweleryarrivalAcceccories_Jeweleryarrivalitemsone__nD0vk","Webmodalbutton":"JeweleryarrivalAcceccories_Webmodalbutton__55Wqk","Mobilemodalbutton":"JeweleryarrivalAcceccories_Mobilemodalbutton__ZBcjC","Jeweleryarrivalitemstwo":"JeweleryarrivalAcceccories_Jeweleryarrivalitemstwo__7uP3t","Jeweleryarrivalsaliderboxmain":"JeweleryarrivalAcceccories_Jeweleryarrivalsaliderboxmain__xFX0F","Jeweleryarrivalsaliderbox":"JeweleryarrivalAcceccories_Jeweleryarrivalsaliderbox__fsJZF","sliderhover":"JeweleryarrivalAcceccories_sliderhover__2QVLY","Sliderhoverinner":"JeweleryarrivalAcceccories_Sliderhoverinner__Sw9x9","Sliderhgovercontentone":"JeweleryarrivalAcceccories_Sliderhgovercontentone__PreAp","Sliderhgovercontenttwo":"JeweleryarrivalAcceccories_Sliderhgovercontenttwo__quos3"};

/***/ }),

/***/ 36320:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"WeekofoffersectionMain":"Weekofoffersection_WeekofoffersectionMain__Xx_T2","Weekofoffersectionfirst":"Weekofoffersection_Weekofoffersectionfirst__7OlwH","Watchimage":"Weekofoffersection_Watchimage__T3fcg","SaleTicketImage":"Weekofoffersection_SaleTicketImage__1GlGS","timelesscontentmain":"Weekofoffersection_timelesscontentmain__s_JGF"};

/***/ }),

/***/ 34684:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hotWatchesSection":"HotWatches_hotWatchesSection__bPP7I","hotWatchesHeader":"HotWatches_hotWatchesHeader__PvMAV","seeMoreButton":"HotWatches_seeMoreButton__uIvGC","mobileview":"HotWatches_mobileview__UYMPm","webview":"HotWatches_webview__ega12","hotWatchesDetailsBox":"HotWatches_hotWatchesDetailsBox__FYy0k","hotWatchesBannerImg":"HotWatches_hotWatchesBannerImg__tuauX","hotWatchesAllDetails":"HotWatches_hotWatchesAllDetails__TNm4V","hotWatchesGrid":"HotWatches_hotWatchesGrid___XUKO","watchesSliderImg":"HotWatches_watchesSliderImg__OvDmx","nextArrowAlignment":"HotWatches_nextArrowAlignment__A_x5E","prevArrowAlignment":"HotWatches_prevArrowAlignment__CXgIT"};

/***/ }),

/***/ 16217:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"shopByCategorySection":"ShopByCategoryDetails_shopByCategorySection__5GS8F","shopByCategoryChildDetails":"ShopByCategoryDetails_shopByCategoryChildDetails__DcFbs"};

/***/ }),

/***/ 73784:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"specialOffersSetion":"SpecialOffers_specialOffersSetion__j03eO","specialOffersHeader":"SpecialOffers_specialOffersHeader___mbQz","seeMoreButton":"SpecialOffers_seeMoreButton__UpZVr","webView":"SpecialOffers_webView__oXjLY","mobileView":"SpecialOffers_mobileView__IyY4x","specialOffersBodyAlignment":"SpecialOffers_specialOffersBodyAlignment___0d6i","specialOffersGrid":"SpecialOffers_specialOffersGrid__9d_p9"};

/***/ }),

/***/ 19746:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jewelryClubsSection":"JewelryClubs_jewelryClubsSection__px__E","jewelryClubflxmain":"JewelryClubs_jewelryClubflxmain__mEEAc","JeweleryClubheading":"JewelryClubs_JeweleryClubheading__T4O7S","clubModalDetailsAllDetailsAlignment":"JewelryClubs_clubModalDetailsAllDetailsAlignment__g8uEa"};

/***/ })

}]);